/**
 * @generated SignedSource<<360a092d129e9c06ea7be54f369f7b9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type timeRegisteredPerPersonPortfolio_viewer$data = {
  readonly insightComponentsData: {
    readonly timeRegisteredPerPersonPortfolio: {
      readonly id: string;
      readonly startWeekOnMonday: boolean | null;
      readonly mondayRegistered: number | null;
      readonly mondayWorkingHours: number | null;
      readonly tuesdayRegistered: number | null;
      readonly tuesdayWorkingHours: number | null;
      readonly wednesdayRegistered: number | null;
      readonly wednesdayWorkingHours: number | null;
      readonly thursdayRegistered: number | null;
      readonly thursdayWorkingHours: number | null;
      readonly fridayRegistered: number | null;
      readonly fridayWorkingHours: number | null;
      readonly saturdayRegistered: number | null;
      readonly saturdayWorkingHours: number | null;
      readonly sundayRegistered: number | null;
      readonly sundayWorkingHours: number | null;
      readonly totalRegistered: number | null;
      readonly totalWorkingHours: number | null;
      readonly listData: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly role: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly mondayRegistered: number | null;
        readonly mondayWorkingHours: number | null;
        readonly tuesdayRegistered: number | null;
        readonly tuesdayWorkingHours: number | null;
        readonly wednesdayRegistered: number | null;
        readonly wednesdayWorkingHours: number | null;
        readonly thursdayRegistered: number | null;
        readonly thursdayWorkingHours: number | null;
        readonly fridayRegistered: number | null;
        readonly fridayWorkingHours: number | null;
        readonly saturdayRegistered: number | null;
        readonly saturdayWorkingHours: number | null;
        readonly sundayRegistered: number | null;
        readonly sundayWorkingHours: number | null;
        readonly totalRegistered: number | null;
        readonly totalWorkingHours: number | null;
        readonly nestedListData: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null;
          readonly mondayRegistered: number | null;
          readonly tuesdayRegistered: number | null;
          readonly wednesdayRegistered: number | null;
          readonly thursdayRegistered: number | null;
          readonly fridayRegistered: number | null;
          readonly saturdayRegistered: number | null;
          readonly sundayRegistered: number | null;
          readonly totalRegistered: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "timeRegisteredPerPersonPortfolio_viewer";
};
export type timeRegisteredPerPersonPortfolio_viewer$key = {
  readonly " $data"?: timeRegisteredPerPersonPortfolio_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeRegisteredPerPersonPortfolio_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mondayRegistered",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mondayWorkingHours",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesdayRegistered",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesdayWorkingHours",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesdayRegistered",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesdayWorkingHours",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursdayRegistered",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursdayWorkingHours",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fridayRegistered",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fridayWorkingHours",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturdayRegistered",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturdayWorkingHours",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sundayRegistered",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sundayWorkingHours",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRegistered",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalWorkingHours",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "roleIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "weekPickerSelectedDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "timeRegisteredPerPersonPortfolio_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "componentId",
              "variableName": "componentId"
            },
            {
              "kind": "Variable",
              "name": "labelIds",
              "variableName": "labelIds"
            },
            {
              "kind": "Variable",
              "name": "personIds",
              "variableName": "personIds"
            },
            {
              "kind": "Variable",
              "name": "roleIds",
              "variableName": "roleIds"
            },
            {
              "kind": "Variable",
              "name": "teamIds",
              "variableName": "teamIds"
            },
            {
              "kind": "Variable",
              "name": "weekPickerSelectedDate",
              "variableName": "weekPickerSelectedDate"
            }
          ],
          "concreteType": "TimeRegisteredPerPersonPortfolio",
          "kind": "LinkedField",
          "name": "timeRegisteredPerPersonPortfolio",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWeekOnMonday",
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegisteredPerPersonPortfolioListElement",
              "kind": "LinkedField",
              "name": "listData",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v17/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/),
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeRegisteredPerPersonPortfolioListElement",
                  "kind": "LinkedField",
                  "name": "nestedListData",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v17/*: any*/),
                    (v1/*: any*/),
                    (v3/*: any*/),
                    (v5/*: any*/),
                    (v7/*: any*/),
                    (v9/*: any*/),
                    (v11/*: any*/),
                    (v13/*: any*/),
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7d8f5ac0d0d97b7058a2d0c4839371f5";

export default node;
